import React, { forwardRef, useImperativeHandle, useState } from 'react'

import { Botao, ModalBase, ModalBaseProps, ModalRef } from 'src/componentes'

import { ContainerDosBotoes, CorpoModal } from './styles'

export interface ModalConfirmacaoSituacaoAlunoRef
  extends Omit<ModalRef, 'abrir'> {
  abrir: (
    onConfirmar: () => void,
    mensagemOpcional?: string | JSX.Element
  ) => void
}

const ModalConfirmacaoComponent: React.ForwardRefRenderFunction<
  ModalConfirmacaoSituacaoAlunoRef,
  ModalBaseProps
> = ({ backdrop }, ref) => {
  const [aberta, definirAberta] = useState(false)
  const [mensagem, definirMensagem] = useState<string | JSX.Element>(null)
  const [acaoConfirmar, definirAcaoConfirmar] = useState<(() => void) | null>(
    null
  )

  const abrir = (
    onConfirmar: () => void,
    mensagemOpcional?: string | JSX.Element
  ) => {
    definirMensagem(
      mensagemOpcional ?? 'Tem certeza que deseja confirmar esta ação?'
    )
    definirAcaoConfirmar(() => onConfirmar)
    definirAberta(true)
  }

  const fechar = () => {
    definirAberta(false)
    definirMensagem(null)
    definirAcaoConfirmar(null)
  }

  useImperativeHandle(ref, () => ({
    abrir,
    fechar
  }))

  return (
    <ModalBase id="modal-confirmacao" backdrop={backdrop} aberta={aberta}>
      <CorpoModal>
        {/* TÍTULO DO MODAL */}
        <h2 style={{ marginBottom: '15px', fontSize: '22px', fontWeight: 600 }}>
          Tem certeza?
        </h2>

        {/* TEXTO DA MENSAGEM */}
        <div
          style={{ padding: '0 20px', fontSize: '16px', textAlign: 'center' }}
        >
          {typeof mensagem === 'string' ? <p>{mensagem}</p> : mensagem}
        </div>

        {/* BOTÕES */}
        <ContainerDosBotoes>
          <Botao
            texto="Cancelar"
            tema="Secundario"
            type="button"
            onClick={() => {
              fechar()
            }}
          />
          <Botao
            texto="Confirmar"
            type="button"
            onClick={() => {
              fechar()
              acaoConfirmar && acaoConfirmar()
            }}
          />
        </ContainerDosBotoes>
      </CorpoModal>
    </ModalBase>
  )
}

export const ModalConfirmacaoSituacaoAluno = forwardRef(
  ModalConfirmacaoComponent
)
